import { observer } from 'mobx-react';
import useAsyncEffect from 'use-async-effect';
import { SpcSteps } from './SpcModels';
import { useParams } from 'react-router-dom';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
import { Button, InputOptionBox } from '../../../../core/components/Index';
import { useState } from 'react';
import Helper, { formatDate } from '../../../../core/services/Helper';

const Summary = observer(() => {
  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  let { memberId } = useParams();
  useAsyncEffect(async () => {
    console.log("Loading Summary Page");
    await vm.loadStepAsync(SpcSteps.Summary, memberId!!);
  }, []);
  
  const searchParams = new URLSearchParams();
  const type_chosen = vm.model?.spcTypeId;

  //Getting Variables from URL:
  useAsyncEffect(async () => {
      const paramsToSearch = new URLSearchParams(window.location.search);
      const url_spcTypeId = paramsToSearch.get('spcTypeId');
      const url_spcTypeSubId = paramsToSearch.get('spcTypeSubId');
      searchParams.set('spcTypeId', String(url_spcTypeId));
      searchParams.set('spcTypeSubId', String(url_spcTypeSubId));
  });

  return (
    <>
    <div className="w-full mx-auto max-w-[890px] p-[10px]">
        <div> 
          <div>
            <h1 className="text-32px tracking-[-1%] text-[#363636] font-semibold !mb-[0px]">Estimate Details Summary — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
            <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[24px]">
            {vm.model?.spcTypeId===1 && <p className ="pt-3 pb-3">You're all set. Review the leave period below. You can add another period (up to 5, no overlap) or continue to generate your preliminary estimate.</p>}
            {vm.model?.spcTypeId===2 && 
            <>
            <p className ="pt-3 pb-3">Review the information you've entered for your temporary, seasonal, or on-call employment. Each period you provided is listed below.</p>
            <ul className="mb-[40px] space-y-[2px] ml-[10px] tracking-[1.5%]">
              <li className="flex items-start gap-2">
                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                <span className="">
                  You can add another employment period (up to a total of five).
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                <span className="">
                  You can edit or delete any period before proceeding.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                <span className="">
                  You must acknowledge the statement below before continuing to your preliminary estimate.
                </span>
              </li>
            </ul>
            </>
            }
            {vm.model?.spcTypeId===3 && 
            <>
            <p className ="pt-3 pb-3 !mb-[8px]">Review the information you've entered for your redeposit estimate. Each withdrawal you provide is listed below.</p>
              <ul className="mb-[40px] space-y-[6px] ml-[10px]">
                <li className="flex items-start gap-2">
                  <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="leading-tight">
                    You may enter up to five separate withdrawal events.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="leading-tight">
                    Withdrawals cannot overlap in time.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="leading-tight">
                    You can edit or delete any withdrawal before proceeding.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="leading-tight">
                    You must acknowledge the statement below before continuing to your preliminary estimate.
                  </span>
                </li>
              </ul>
            </>}
            {vm.model?.spcTypeId===4 && 
            <>
            <p className ="pt-3 pb-3 !mb-[8px]">Review the information you’ve entered for your prior public service. Each period you provide is listed below.</p>
             <ul className="mb-[40px] space-y-[6px] ml-[10px]">
                <li className="flex items-start gap-2">
                  <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="leading-tight">
                    You may enter up to five separate periods of public service.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="leading-tight">
                    The total purchase cannot exceed four (4) years of credit, and service dates cannot overlap.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="leading-tight">
                    If you later become eligible for a pension from the public employer, SCERS may adjust the purchased service credit.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="leading-tight">
                    You’ll need to provide the same information for each service period you enter.
                  </span>
                </li>
              </ul>
            </>
            }
            </div>
            <h2 className="text-[22px] font-semibold text-[#363636] leading-[100%] tracking-[0px] mt-[20px] !mb-[36px]"           >
              Your Information
            </h2>
          </div>
        </div>
      <div className="flex flex-wrap gap-[49px] mt-[20px]">
        
      {vm.model.estimateDetails?.map((detail, index) => {
            return (
              <div key={index} className={`w-full max-w-[400px] h-[${(vm.model?.spcTypeId===1 || vm.model?.spcTypeId===2)?'406px':vm.model?.spcTypeId===3?'306px':'436px'}] bg-[#F7F3ED] border border-[#DEDEDE] rounded-[4px] p-[24px] flex flex-col`}>
                <div className="!mb-[0px]">
                 {vm.model?.spcTypeId!==3 && <><h3 className="text-[22px] font-semibold text-[#557122] leading-[120%] mb-[4px]">
                    {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}
                  </h3>
                  <p className="text-[20px] font-semibold text-[#557122] leading-[150%] !mb-[24px]">
                    {(vm.model?.spcTypeId===1 || vm.model?.spcTypeId===2)? `Leave Period ${index + 1}` : `Period ${index + 1}`}
                  </p>
                  </>
                  }
                 {vm.model?.spcTypeId===3 && <><h3 className="text-[22px] font-semibold text-[#557122] leading-[120%] mb-[0px]">
                    Withdrawal Details
                  </h3>
                  <p className="text-[20px] font-semibold text-[#557122] leading-[150%] !mb-[32px]">
                    Withdrawn Contributions {index + 1}
                  </p>
                  </>
                  }
                  {(vm.model?.spcTypeId==1 || vm.model?.spcTypeId==2) && 
                  <div className="space-y-[10px] text-[15px] font-normal opacity-[60%]">
                    <div className="flex justify-between">
                      <span className="text-[15px] whitespace-nowrap">Employer</span>
                      <span className="text-right break-words">{vm.spcLovModel.employerListItems?.find(o=>o.value===detail.mbrEmployer)?.code}</span>
                    </div>
                    {(vm.model?.spcTypeId===2) && <div className="flex justify-between">
                    <span className="text-[15px]">Membership Entry Date</span>
                    {/* <span>{detail.mbrEntryDate ? new Date(detail.mbrEntryDate).toLocaleDateString() : ""}</span> */}
                    <span>{formatDate(detail.mbrEntryDate)}</span>
                    </div>}
                    <div className="flex justify-between">
                      <span className="text-[15px]">Membership Tier</span>
                      <span>
                        {
                          vm.spcLovModel.membershipTierListItems
                            ?.find(tier => tier.key === detail.mbrTierId)
                            ?.value ?? ""
                        }
                      </span>
                    </div>
                    <div className="flex justify-between">
                      {vm.model?.spcTypeId===1 && <span className="text-[15px]">Dates of Leave</span>}
                      {vm.model?.spcTypeId===2 && <span className="text-[15px]">Dates of Employment</span>}
                      <span>
                         {`${formatDate(detail.startDate)} - ${formatDate(detail.endDate)}`}
                        {/* {detail.startDate ? new Date(detail.startDate).toLocaleDateString() : ""}
                        {" - "}
                        {detail.endDate ? new Date(detail.endDate).toLocaleDateString() : ""} */}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[15px]">Est. Hours</span>
                      <span> 
                        {Helper.formatWholeNumber(
                          (detail.estSvcHours ?? 0) + ((detail.estSvcSplitHours ?? 0) > 0 ? (detail.estSvcSplitHours ?? 0) : 0)
                        )
                        }
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[15px] !mb-[12px]">Est. Compensation</span>
                      <span>
                        {
                          detail.estmComp
                            ? `${Helper.formatCurrency(detail.estmComp)} `
                            : ""
                        }
                        {
                          vm.spcLovModel.compensationFrequencyListItems
                            ?.find(freq => freq.key === detail.comFreqId)
                            ?.value ?? ""
                        }
                      </span>
                    </div>
                  </div>
                }
                {vm.model?.spcTypeId===3 && <div className="text-[15px] font-normal opacity-[60%]">
                    <div className="flex justify-between">
                      <span className="mb-[10px]">Withdrawal Date</span>
                      {/* <span>{formatdetail.withdrawDate ? new Date(detail.withdrawDate).toLocaleDateString() : ""}</span> */}
                      <span>{formatDate(detail.withdrawDate)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="mb-[16px]">Amount Withdrawn</span>
                      <span>{
                          detail.withdrawAmount
                            ? `${Helper.formatCurrency(detail.withdrawAmount)} `
                            : ""
                        }
                        </span>
                    </div>
                    </div>
                }
                {(vm.model?.spcTypeId==4) && 
                  <div className="space-y-[10px] text-[15px] font-normal opacity-[60%]">
                    <div className="flex justify-between">
                    <span className="text-[15px]">Membership Entry Date</span>
                    {/* <span>{detail.mbrEntryDate ? new Date(detail.mbrEntryDate).toLocaleDateString() : ""}</span> */}
                    <span>{formatDate(detail.mbrEntryDate)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[15px]">Membership Tier at Entry</span>
                      <span>
                        {
                          vm.spcLovModel.membershipTierListItems
                            ?.find(tier => tier.key === detail.mbrTierId)
                            ?.value ?? ""
                        }
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[15px] whitespace-nowrap">SCERS Employer</span>
                      <span className='text-right break-words'>{vm.spcLovModel.employerListItems?.find(o=>o.value===detail.mbrEmployer)?.code}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[15px]">Dates of Service</span>
                      <span>
                        {`${formatDate(detail.startDate)} - ${formatDate(detail.endDate)}`}
{/*                     {detail.startDate ? new Date(detail.startDate).toLocaleDateString() : ""}
                        {" - "}
                        {detail.endDate ? new Date(detail.endDate).toLocaleDateString() : ""} */}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[15px]">Est. Hours</span>
                      <span> 
                        {Helper.formatWholeNumber(
                          (detail.estSvcHours ?? 0) + ((detail.estSvcSplitHours ?? 0) > 0 ? (detail.estSvcSplitHours ?? 0) : 0)
                        )
                        }
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[15px] !mb-[12px]">Est. Compensation</span>
                      <span>
                        {
                          detail.estmComp
                            ? `${Helper.formatCurrency(detail.estmComp)} `
                            : ""
                        }
                        {
                          vm.spcLovModel.compensationFrequencyListItems
                            ?.find(freq => freq.key === detail.comFreqId)
                            ?.value ?? ""
                        }
                      </span>
                    </div>
                  </div>
                }
                  <div className="w-full border-b border-[#333333] opacity-[20%] mt-[20px]"></div>
                </div>
                <div className="flex justify-center items-center gap-[24px] !mt-[32px]">
                  <Button className="mr-2 w-[76px] h-[39px] border border-[#345719]" title="Edit" rounded onClick={async () => {console.log("This is the index, ", index); await vm.editEstimationAsync(index, searchParams.toString());}} />
                  <Button className="mr-2 w-[94px] h-[39px]" title="Delete" severity='warning' outlined rounded style={{ backgroundColor: 'white', color: 'rgb(207 113 25)' }} onClick={() => Appl.ConfirmBox.show('If you proceed, this item will be permanently removed from your estimate.', 'Are You Sure You Wish to Delete?', '', "Yes, I am sure", 'Cancel', async () => await vm.removeEstimationAsync(index), undefined, true)} />
                </div>
              </div>
            );
        })}
        {vm.model.estimateDetails 
          && vm.model.estimateDetails.length! < 5 
          && (
            vm.model.estimateDetails.length! % 2 === 1 ? (

              // Small Odd Box
              <div className={`w-full max-w-[400px] h-[${(vm.model?.spcTypeId===1 || vm.model?.spcTypeId===2)?'406px':vm.model?.spcTypeId===3?'306px':'436px'}] border-[3px] border-dashed border-[#D0CDC8] rounded-[4px] flex flex-col items-center justify-center p-[20px] gap-[8px] text-center`}>
                <p className="text-[20px] max-w-[157px] font-semibold text-[#54752E] mb-[8px]">
                  Add Additional {
                    vm.model?.spcTypeId === 1 || vm.model?.spcTypeId === 2
                      ? 'Leave Period'
                      : vm.model?.spcTypeId === 3
                        ? 'Withdrawal'
                        : vm.model?.spcTypeId === 4
                          ? 'Employment Period'
                          : 'Period'
                  }
                </p>

                <button
                  type="button"
                  onClick={async () => { await vm.addNewEstimationAsync(); }}
                  className="w-[39px] h-[37px] rounded-full bg-[#54752E] text-white text-[28px] flex items-center justify-center"
                >
                  +
                </button>
                <p className="text-[13px] max-w-[290px] leading-[150%] tracking-[-1%] mt-[32px]">
                  Note: Up to 5 total.{" "}
                  {vm.model?.spcTypeId === 1 &&
                    "Leave periods can’t overlap; you must have returned to SCERS-covered employment after each leave."}

                  {vm.model?.spcTypeId === 2 &&
                    "Leave periods can’t overlap."}
                </p>
              </div>

            ) : (

              // EVEN Wide Box
              <div className="basis-[400px] grow w-full max-w-[849px] min-h-[145px] h-auto border-[3px] border-dashed border-[#D0CDC8] rounded-[4px] flex flex-col items-center justify-center p-[20px] gap-[8px] text-center">
                <p className="text-[22px] font-semibold text-[#54752E] mb-[8px]">
                 Add Additional {
                  vm.model?.spcTypeId === 1 || vm.model?.spcTypeId === 2
                    ? 'Leave Period'
                    : vm.model?.spcTypeId === 3
                      ? 'Withdrawal'
                      : vm.model?.spcTypeId === 4
                        ? 'Employment Period'
                        : 'Period'
                }
                </p>

                <button
                  type="button"
                  onClick={async () => { await vm.addNewEstimationAsync(); }}
                  className="w-[39px] h-[37px] rounded-full bg-[#54752E] border border-[#345719] text-white text-[32px] flex items-center justify-center"
                >
                  <div className='h-[17px] w-[17px] flex items-center justify-center'>
                    +
                  </div>
                </button>
                <p className="text-[13px] leading-[150%] tracking-[-1%] mt-[8px]">
                  Note: Up to 5 total.{" "}
                  {vm.model?.spcTypeId === 1 &&
                    "Leave periods can’t overlap; you must have returned to SCERS-covered employment after each leave."}

                  {vm.model?.spcTypeId === 2 &&
                    "Leave periods can’t overlap."}
                </p>
              </div>

            )
          )
        }
        </div>
        <div className="mt-[32px]">
          <p className="pt-3 font-bold mb-[20px]">
              Acknowledgment
          </p>
          <div className="text-[15px] leading-[175%] tracking-[-1.5%] mb-[20px]">
            <p>
              This tool provides an <span className="font-bold">estimate only</span>. 
              It does not create any rights or guarantees under the County Employees’ Retirement Law of 1937. 
              Final costs may be higher or lower once SCERS reviews your account and verifies payroll records.
            </p>
            <p className="mt-[20px]">
              By checking the box below, I understand that:
            </p>
            <ul className="mt-[20px] space-y-[6px]">
              <li className="flex items-start gap-2">
                <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                <span className="leading-tight">
                  The estimate is <span className="font-bold">preliminary and subject to change</span>.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                <span className="leading-tight">
                  The <span className="font-bold">accuracy of the estimate</span> depends on the information I provide.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                <span className="leading-tight">
                  An <span className="font-bold">official request (Form 6401)</span> is required for SCERS to determine the actual cost of purchasing service credit.
                </span>
              </li>
              {(type_chosen === 4) &&
                <li className="flex items-start gap-2">
                <span className="mt-[8px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                <span className="leading-tight">
                  This estimate is based on the full member contribution rate and may not reflect phase-ins, pick-ups, or alternate rates that were less than the full member contribution rate for certain bargaining units in specific years.
                </span>
              </li>
              }
            </ul>

          </div>
          <div className="flex items-center gap-[10px] mt-[32px] mb-[64px]">
             <InputOptionBox
                inputId="spcAck"
                value={vm.model.spcAck}
                checked={vm.model.spcAck === "Y"}
                disabled={vm.model.estimateDetails?.length===0}
                onChange={(e: any) => { e.target.checked ? vm.model.spcAck = "Y" : vm.model.spcAck = "N" }}
              />
             <label htmlFor="spcAck" className="text-[15px] leading-[175%] tracking-[-1.5%]"         >
              I acknowledge and accept the above terms.
            </label>
          </div>
        </div>
        <div className="flex mt-6 flex-wrap gap-2 sm:flex-nowrap">
            <Button 
              title="Save & Continue" 
              className='border border-[#345719]'
              rounded
              disabled={vm.model.spcAck!=='Y'}
              onClick={async () => {
                await vm.onSummaryStepChangeAsync();
              }}
            />
        </div>
      </div>
    </>
  );
});

export default Summary;
